import { jsx } from "react/jsx-runtime";
import React from "react";
var checkmark_green_small_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17 9c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8z",
        fill: "rgb(var(--colour-semantic-positive, 10, 138, 0))"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13.7083 7.207-5.7086 5.7062-3.7069-3.707L5.7071 7.792 8 10.085l4.2942-4.2925 1.414 1.4145z",
        fill: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))"
      }
    )
  ];
};
export {
  checkmark_green_small_default as default
};
